import React from "react";
import Select from "react-select";

const FancySelect = ({ name, handleChange, labelText, value, options, isMulti }) => {
	// options must be an array of objects with key and text for keys [{ value: row.id, label: row.text }]
	const formattedValues = value?.map((val) => {
		const matches = options.filter((row) => row.value === val);
		return matches[0];
	});

	return (
		<div className="form-row">
			<label htmlFor={name} className="form-label">
				{labelText || name}
			</label>
			<Select
				isMulti={isMulti}
				name={name}
				id={name}
				onChange={(selected) => handleChange(selected, name)}
				value={formattedValues}
				options={options}
				styles={{
					control: (baseStyles) => ({
						...baseStyles,
						backgroundColor: 'var(--backgroundColor)'
					}),
					valueContainer: (styles) => {
						return {
							...styles,
							padding: '0 .5em',
						};
					},
					input: (styles) => ({
						...styles,
						padding: 0,

					}),
					multiValue: (styles) => ({
						...styles,
						margin: '0 2px',

					}),
				}}
			/>
		</div>
	);
};
export { FancySelect };
